module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j6mSy"))).then(() => parcelRequire('hEqeo'));